import React, { useState, useContext, useEffect } from 'react';
import useAsyncEffect from 'use-async-effect';
import AppContext from 'contexts/appContext';
import Panel from 'components/common/panel/panel';
import moment from 'moment';
import BoardingService from 'services/boardingService';

export default function BoardingConfirmationPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  const id = props.match.params.id;

  const [confirmation, setConfirmation] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setAppArea(AppContext.Areas.Boarding, 'Boarding');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Boarding' }, { name: 'Board New Sites', selected: true }]);
  }, []);

  useAsyncEffect(async () => {
    setConfirmation(await BoardingService.API.getOrderConfirmation(id));
    setLoaded(true);
  }, []);

  if (!loaded) {
    return null;
  }
  if (confirmation) {
    return <BoardingConfirmationSuccess data={confirmation} />;
  }
  else {
    return <BoardingConfirmationError />;
  }
}

function BoardingConfirmationSuccess(props) {
  const data = props.data || {};

  return (
    <div className='row justify-content-center mt-4 mx-0'>
      <div className='col-10 col-md-7 col-lg-6 col-xl-5'>
        <Panel variant='success'>
          <Panel.Header>Confirmation</Panel.Header>
          <Panel.Body>
            <div className='text-center'>
              <div className='text-success' style={{ fontSize: 100, lineHeight: 1 }}><i className='icons8-ok-2' /></div>
              <h3 className='text-success mt-3'>Boarding Order Submitted</h3>
            </div>
            <div className='mt-4'>
              <div className='mb-2'>
                <div><div className='form-label'>Site</div></div>
                <div>{data.storeName}</div>
              </div>
              <div className='mb-2'>
                <div><div className='form-label'>Order Id</div></div>
                <div>{data.id}</div>
              </div>
              <div className='mb-2'>
                <div><div className='form-label'>Order Status</div></div>
                <div>{data.status}</div>
              </div>
              <div className='mb-2'>
                <div><div className='form-label'>Date Submitted</div></div>
                <div>{moment(data.created).format('L LT')}</div>
              </div>
              <div className='mb-2'>
                <div><div className='form-label'>Instructions</div></div>
                <ul className='px-4'>
                  <li>If an agent is not already installed at this site, it should be installed now. The agent installer can be downloaded from <a href='https://static.positouchcloud.com/agent/setup'>https://static.positouchcloud.com/agent/setup</a></li>
                  <li>When registering POSitouch, the registration code for this site is <span className='text-thicker'>{data.registrationCode}</span></li>
                </ul>
              </div>
            </div>
            <div className='mt-4'>
              <div><a href={`/Boarding/Order/${data.id}`}>View Order Status</a></div>
              <div><a href='/Boarding/Wizard'>Board More Sites</a></div>
            </div>
          </Panel.Body>
        </Panel>
      </div>
    </div >
  );
}

function BoardingConfirmationError(props) {
  return (
    <div className='row justify-content-center mt-4 mx-0'>
      <div className='col-10 col-md-7 col-lg-6 col-xl-5'>
        <Panel variant='danger'>
          <Panel.Header>Problem</Panel.Header>
          <Panel.Body>
            <div className='text-center'>
              <div className='text-danger' style={{ fontSize: 100, lineHeight: 1 }}><i className='icons8-error-2' /></div>
              <h3 className='text-danger mt-3'>Boarding Order Submission Failed</h3>
            </div>
            <div className='mt-4'>
              <div className='mb-2'>
                Something went wrong, the submitted order could not be located
              </div>
            </div>
            <div className='mt-4'>
              <div><a href='/Boarding/Wizard'>Board More Sites</a></div>
            </div>
          </Panel.Body>
        </Panel>
      </div>
    </div>
  );
}